var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.00781H10V0.0078125H4V6.00781H0L7 13.0078L14 6.00781ZM6 8.00781V2.00781H8V8.00781H9.17L7 10.1778L4.83 8.00781H6ZM0 15.0078H14V17.0078H0V15.0078Z",
    fill: "#805D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBrown);
export default __webpack_public_path__ + "static/media/download_brown.c9cd93a3.svg";
export { ForwardRef as ReactComponent };